<template>
  <popup
     v-if="this.isManager('project|maintenance|finance|admin')"
    :button-style="addProvider ? 'primary' : 'info'"
    :heading="'New Backhaul ' + (sharerName ? 'for ' + sharerName : (addProvider ? 'Provider' + (siteName ? ': ' + siteName : '') : 'Customer'))"
    :show-text="showText"
    :button-text="addProvider ? 'Provider' : 'Customer'"
    size="medium"
    buttonSize="small"
    button-icon="fa fa-plus"
    :disable-button="readOnly"
    :table-ref="tableRef"
    :show-cancel="false"
    :show-save="false"
    @save="onCloseDialog"
    @close="onCloseDialog">

    <div class="padded" style="clear: both; text-align: left;">

      <backhaul-provider
      v-if="provider"
        id="bkp"
       :site-id="siteId"
       :sharer-id="sharerId"
       :is-new="true"
       :edit-mode="true"
       :show-edit-button="false" />

       <backhaul-customer
       v-else
         id="bks"
        :site-id="siteId"
        :sharer-id="sharerId"
        :is-new="true"
        :edit-mode="true"
        :show-edit-buton="false" />

    </div>

  </popup>

</template>



<script>

import Vue from 'vue'
import VueEvents from 'vue-events'

import BackhaulProvider from '@/components/backhaul/BackhaulProvider'
import BackhaulCustomer from '@/components/backhaul/BackhaulCustomer'

Vue.use(VueEvents)

export default {

  name: 'BackhaulAction',

  components: {
    BackhaulProvider,
    BackhaulCustomer
  },

  props: {

    showText: {
      type: Boolean,
      default: true
    },

    provider: {
      type: Boolean,
      required: true,
      default: true
    },

    siteId: {
      type: [String, Number],
      default: null
    },

    sharerId: {
      type: [String, Number],
      default: null
    },

    siteName: {
      type: String,
      default: null
    },

    sharerName: {
      type: String,
      default: null
    },

    siteData: {
      type: Object,
      default: null
    },

    tableRef: {
      type: String,
      default: 'backhaultable'
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  methods: {

    resetData () {
      this.telco = this.getTableStruct('backhaul' + (this.provider ? '' : '_subscribers'))
      this.telco.site_id = this.siteId ? this.siteId : this.rowData.site_id
    },

    onSaveDialog () {
      if (this.provider) {
        this.$refs.bkp.onAdd(this.success)
      } else {
        this.$refs.bks.onAdd(this.success)
      }

      this.onCloseDialog()
    },

    onCloseDialog () {
      this.resetData()

      this.$emit('update-stats')

      if (this.tableRef) {
        this.$events.fire(this.tableRef + '-refresh-table')
      }

      this.$refs.backhaulAdd.closeModal()
    },

    success () {
      if (this.tableRef) {
        this.$events.fire(this.tableRef + '-refresh-table')
      }
    }
  },

  data () {
    return {
      tenor: 10,
      addProvider: (this.sharerId || !this.provider ? false : true),
      backhaul: this.getTableStruct('backhaul' + (this.provider ? '' : '_subscribers'))
    }
  },

  mounted () {
//    console.log('Add Backhaul: site_id', this.siteId, 'sharerId', this.sharerId, 'siteData', this.siteData)
  }
}

</script>



// WEBPACK FOOTER //
// BackhaulAction.vue?5cc47e37